export default __webpack_public_path__ + "static/img/promo-back.4cca830.png";